import React, { Component } from 'react';
import { Modal, message, Table, Button, Input, Select, Checkbox, Upload, Icon, Popconfirm } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import EvaluateSiteUpdate from './EvaluateSiteUpdate';

const Option = Select.Option;

class EvaluateSite extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
            total: 0,
        },
        searchParams: {
            hospitalName: '',
            deptName: '',
        },
        selectedRowKeys: [],
        evaluateRecordId: null,
        hasOperationAuth: false,
        canMarkSiteGetOrder: false,
    }

    show = (record) => {
        const { evaluateRecordId } = record;
        // 从主列表记录中获取操作权限：部门BO/领域leader/PM
        const hasOperationAuth = record.deptBoAuth || record.talAuth || record.pmAuth;
        // 判断是否可以标记获单中心：businessOpportunityCode 在指定状态列表中才可操作
        const markAllowedCodes = ['perception_acceptance', 'contract_negotiation', 'po_pending', 'won', 'win_piece'];
        const canMarkSiteGetOrder = markAllowedCodes.includes(record.businessOpportunityCode);
        this.setState({
            evaluateRecordId,
            visible: true,
            hasOperationAuth: !!hasOperationAuth,
            canMarkSiteGetOrder,
            pagination: { pageSize: 10, current: 1, total: 0 },
            searchParams: { hospitalName: '', deptName: '' },
            selectedRowKeys: [],
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            data: [],
            selectedRowKeys: [],
            hasOperationAuth: false,
            canMarkSiteGetOrder: false,
        });
    }

    loadData = () => {
        const { pagination, searchParams, evaluateRecordId } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecordSiteByPage,
            data: {
                offset: current,
                limit: pageSize,
                evaluateRecordId,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: data || [],
                    pagination,
                });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    handleSearchChange = (key, value) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    // 标记获单中心/取消标记获单中心
    handleMarkSiteGetOrder = (record) => {
        const siteGetOrder = (record.siteGetOrder === 1) ? 0 : 1;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.markSiteGetOrder,
            data: {
                evaluateRecordSiteId: record.evaluateRecordSiteId,
                siteGetOrder,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    // 获取过滤掉已关联中心（invSiteId有值且大于0）后的选中记录ID
    getFilteredSelectedIds = () => {
        const { selectedRowKeys, data } = this.state;
        return (selectedRowKeys || []).filter(id => {
            const record = (data || []).find(el => el.evaluateRecordSiteId === id);
            return !(record && record.invSiteId && record.invSiteId > 0);
        });
    }

    // 批量标记获单中心
    handleBatchMarkSiteGetOrder = (siteGetOrder) => {
        const ids = this.getFilteredSelectedIds();
        if (ids.length === 0) {
            return message.warning('请先选择要操作的记录');
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.batchMarkSiteGetOrder,
            data: {
                ids: ids.join(','),
                siteGetOrder,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ selectedRowKeys: [] });
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    // 删除单条
    handleDelete = (evaluateRecordSiteId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.deleteEvaluateRecordSite,
            data: {
                evaluateRecordSiteId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    // 批量删除
    handleBatchDelete = () => {
        const ids = this.getFilteredSelectedIds();
        if (ids.length === 0) {
            return message.warning('请先选择要删除的记录');
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.batchDeleteEvaluateRecordSite,
            data: {
                ids: ids.join(','),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ selectedRowKeys: [] });
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    // 下载模板
    handleDownloadTemplate = () => {
        ExportUtil.export({}, null, API_URL.evaluate.downloadEvaluateSiteTemplate);
        message.success('开始下载模板');
    }

    // 导入
    handleImport = (file) => {
        const { evaluateRecordId } = this.state;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('evaluateRecordId', evaluateRecordId);

        this.setState({ loading: true });
        fetch(API_URL.evaluate.importEvaluateRecordSite, {
            method: 'post',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) return res.json();
        }).then(data => {
            this.setState({ loading: false });
            if (data.error) {
                message.error(data.error);
            } else {
                const errors = data.importErrors;
                if (errors && errors.length > 0) {
                    Modal.warning({
                        title: data.success,
                        width: 520,
                        content: (
                            <div>
                                {errors.map((item, index) => (
                                    <p key={index} style={{ margin: '4px 0' }}>{item}</p>
                                ))}
                            </div>
                        ),
                        okText: '确定',
                    });
                } else {
                    message.success(data.success);
                }
                this.loadData();
            }
        }).catch(err => {
            this.setState({ loading: false });
            message.error('导入失败');
        });
        return false;
    }

    // 新增/修改弹框
    showUpdate = (record) => {
        this.EvaluateSiteUpdateRef.show(record, this.state.evaluateRecordId);
    }

    getColumns = () => {
        const { hasOperationAuth, canMarkSiteGetOrder } = this.state;
        const columns = [
            {
                title: '序号',
                dataIndex: 'sortNum',
                key: 'sortNum',
                width: 50,
            },
            {
                title: '中心名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 150,
            },
            {
                title: '中心院区',
                dataIndex: 'courtyardArea',
                key: 'courtyardArea',
                width: 100,
            },
            {
                title: '中心科室',
                dataIndex: 'deptName',
                key: 'deptName',
                width: 120,
            },
            {
                title: 'PI',
                dataIndex: 'doctorName',
                key: 'doctorName',
                width: 100,
            },
            {
                title: '手机号码',
                dataIndex: 'doctorPhone',
                key: 'doctorPhone',
                width: 120,
            },
            {
                title: '是否为待合作医院科室',
                dataIndex: 'pendingHospitalDept',
                key: 'pendingHospitalDept',
                width: 100,
                render: (text, record) => {
                    return record.pendingHospitalDept ? '是' : '否';
                }
            },
            {
                title: '是否是黑名单',
                dataIndex: 'blackList',
                key: 'blackList',
                width: 80,
                render: (text, record) => {
                    return record.blackList ? '是' : '否';
                }
            },
            {
                title: '中心是否获单',
                dataIndex: 'siteGetOrderShow',
                key: 'siteGetOrderShow',
                width: 80,
            },
        ];
        // 有操作权限才显示操作列
        if (hasOperationAuth) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 200,
                render: (_, record) => {
                    // 已关联中心（invSiteId有值且大于0）的记录，操作栏不显示任何内容
                    if (record.invSiteId && record.invSiteId > 0) {
                        return null;
                    }
                    return (
                        <span>
                            <a onClick={() => this.showUpdate(record)} style={{ marginRight: 8 }}>修改</a>
                            <Popconfirm title="确定删除该关联中心吗？" onConfirm={() => this.handleDelete(record.evaluateRecordSiteId)} okText="确定" cancelText="取消">
                                <a style={{ marginRight: 8 }}>删除</a>
                            </Popconfirm>
                            {
                                record.siteGetOrder === 1 ?
                                canMarkSiteGetOrder ?
                                <a onClick={() => this.handleMarkSiteGetOrder(record)}>取消标记获单中心</a>
                                :
                                <span style={{ color: '#ccc', cursor: 'not-allowed' }}>取消标记获单中心</span>
                                :
                                canMarkSiteGetOrder ?
                                <a onClick={() => this.handleMarkSiteGetOrder(record)}>标记获单中心</a>
                                :
                                <span style={{ color: '#ccc', cursor: 'not-allowed' }}>标记获单中心</span>
                            }
                        </span>
                    );
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const dataSource = [];
        (data || []).map((el, index) => {
            dataSource.push({
                ...el,
                sortNum: (pagination.current - 1) * pagination.pageSize + index + 1,
            });
        });
        return dataSource;
    }

    render() {
        const { visible, loading, pagination, selectedRowKeys, searchParams, hasOperationAuth, canMarkSiteGetOrder } = this.state;

        return (
            <div>
                <Modal
                    title="关联中心"
                    visible={visible}
                    onCancel={this.hide}
                    width="1200px"
                    maskClosable={false}
                    footer={null}
                >
                    <div style={{ marginBottom: 16 }}>
                        <span style={{ marginRight: 8 }}>中心名称：
                            <Input
                                style={{ width: 150, marginRight: 16 }}
                                value={searchParams.hospitalName}
                                onChange={(e) => this.handleSearchChange('hospitalName', e.target.value)}
                                placeholder="请输入中心名称"
                            />
                        </span>
                        <span style={{ marginRight: 8 }}>科室名称：
                            <Input
                                style={{ width: 150, marginRight: 16 }}
                                value={searchParams.deptName}
                                onChange={(e) => this.handleSearchChange('deptName', e.target.value)}
                                placeholder="请输入科室名称"
                            />
                        </span>
                        <Button type="primary" onClick={this.search} style={{ marginRight: 8 }}>搜索</Button>
                        {hasOperationAuth && (
                            <span>
                                <Button disabled={!canMarkSiteGetOrder} onClick={() => this.handleBatchMarkSiteGetOrder(1)} style={{ marginRight: 8 }}>批量标记获单中心</Button>
                                <Button disabled={!canMarkSiteGetOrder} onClick={() => this.handleBatchMarkSiteGetOrder(0)} style={{ marginRight: 8 }}>批量取消标记获单中心</Button>
                                <Popconfirm title="确定批量删除选中的记录吗？" onConfirm={this.handleBatchDelete} okText="确定" cancelText="取消">
                                    <Button style={{ marginRight: 8 }}>批量删除</Button>
                                </Popconfirm>
                                <Button onClick={this.handleDownloadTemplate} style={{ marginRight: 8 }}>下载模板</Button>
                                <Upload
                                    showUploadList={false}
                                    beforeUpload={this.handleImport}
                                    headers={xToken}
                                >
                                    <Button style={{ marginRight: 8 }}>导入</Button>
                                </Upload>
                                <Button type="primary" onClick={() => this.showUpdate(null)}>添加</Button>
                            </span>
                        )}
                    </div>
                    <Table
                        rowSelection={hasOperationAuth ? { selectedRowKeys, onChange: this.onSelectChange } : undefined}
                        dataSource={this.getDataSource()}
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        rowKey="evaluateRecordSiteId"
                        scroll={{ x: 1100 }}
                    />
                    <EvaluateSiteUpdate
                        loadData={this.loadData}
                        ref={el => this.EvaluateSiteUpdateRef = el}
                    />
                </Modal>
            </div>
        );
    }
}

export default EvaluateSite;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/EvaluateSite.js